/**
 * 编辑视图模块路由（优化版）
 */
export default [
  {
    path: "/menu",
    component: resolve => require(["@/views/menu.vue"], resolve),
    redirect: "/menu/website",
    children: [
      {
        path: "website",  // 使用相对路径
        component: resolve => require(["@/modules/website/pages/list.vue"], resolve),
      },
      {
        path: "website/:id",  // 动态参数 :id
        name: "websiteManage",
        component: () => import("@/modules/website/pages/index.vue"),
        redirect: "/menu/website/:id/basic",  // 默认跳转到 basic 配置
        meta: {
          nameText: "网站管理",
        },
        children: [
          {
            path: "basic",  // 相对路径
            name: "websiteBannerType",
            component: () => import("@/modules/website/pages/basic.vue"),
            meta: {
              nameText: "基本配置",
            },
          },
          {
            path: "navtop",  // 相对路径
            name: "navTop",
            component: () => import("@/modules/website/pages/nav/top.vue"),
            meta: {
              nameText: "顶部菜单",
            },
          },
          {
            path: "navbottom",  // 相对路径
            name: "navBottom",
            component: () => import("@/modules/website/pages/nav/bottom.vue"),
            meta: {
              nameText: "底部菜单",
            },
          },
          {
            path: "bannertype",  // 相对路径
            name: "websiteBannerType",
            component: () => import("@/modules/website/pages/banner/type.vue"),
            meta: {
              nameText: "banner分类",
            },
          },
          {
            path: "banner",  // 相对路径
            name: "websiteBanner",
            component: () => import("@/modules/website/pages/banner/list.vue"),
            meta: {
              nameText: "banner管理",
            },
          },
          {
            path: "content",  // 相对路径
            name: "websiteContent",
            component: () => import("@/modules/website/pages/content/list.vue"),
            meta: {
              nameText: "内容管理",
            }
          }
        ]
      }
    ]
  }
];
